import { Injectable } from '@angular/core';

import { Config } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  model: Config = {} as Config;

  constructor() {}

  get config(): Config {
    return this.model;
  }

  async load(): Promise<any> {
    const configResponse = await fetch('assets/config/config.json');
    this.model = await configResponse.json();
    return this.model;
  }
}
